import { Link, makeStyles, shorthands } from "@fluentui/react-components";
import { OpenRegular } from "@fluentui/react-icons";

const useStyles = makeStyles({
    link: {
        color: "#0066cc",
        textDecoration: "underline",
        display: "inline-flex",
        alignItems: "center",
        ...shorthands.gap("4px"),
        ":hover": {
            color: "#0052a3",
            textDecoration: "underline",
        },
        ":visited": {
            color: "#0066cc",
        },
    },
});

interface AdminLinkProps {
    href: string;
    target?: string;
    children: React.ReactNode;
}

const AdminLink = ({ href, target = "_blank", children }: AdminLinkProps) => {
    const styles = useStyles();

    return (
        <Link href={href} target={target} className={styles.link}>
            {children}
            <OpenRegular style={{ fontSize: '12px' }} />
        </Link>
    );
};

export default AdminLink;
